export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Une erreur est survenue";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function eur(n) {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);
}

export const slotLabel = (s) => {
  if (s === "morning") return "Matinée";
  if (s === "afternoon") return "Après-midi";
  if (s === "full_day") return "Journée";
  if (s === "hour") return "Horaire";
  return s;
};

export const spaceTypeLabel = (t) => {
  if (t === "open_space") return "Open Space";
  if (t === "bureau_privatif") return "Bureau Privatif";
  if (t === "salle_reunion") return "Salle de Réunion";
  return t;
};
